<script>
import CandidateDetailItems from './candidate-detail-items.vue'
import CandidateDetailsQualifications from './candidate-details-qualifications.vue'

export default {
  name: 'CandidateDetailsTab',
  components: {
    CandidateDetailItems,
    CandidateDetailsQualifications,
  },
  props: {
    candidate: {
      type: Object,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<template>
  <div class="candidate-details-tab">
    <CandidateDetailItems
      :candidate="candidate"
      :is-loading="isLoading"
      class="mb-6"
    />

    <CandidateDetailsQualifications
      v-if="!isLoading && candidate"
      :candidate="candidate"
    />
  </div>
</template>
